document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

// Keep the theme intentionally simple in Shopify's editor: no reveal animations,
// no DOM replacement and no navigation interception.
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-psx-menu-toggle]');
  if (!trigger) return;
  var id = trigger.getAttribute('aria-controls');
  var panel = document.getElementById(id);
  if (!panel) return;
  var expanded = trigger.getAttribute('aria-expanded') === 'true';
  trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
  panel.hidden = expanded;
});

// Cart: custom +/- selector and automatic Ajax updates. No manual "Actualizar carrito" button.
(function () {
  function initPsxCart() {
    var form = document.querySelector('#psx-cart-form');
    if (!form || form.dataset.psxCartReady === 'true') return;
    form.dataset.psxCartReady = 'true';

    var timers = new Map();
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var locale = document.documentElement.lang || 'es-ES';

    function money(cents) {
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format((Number(cents) || 0) / 100);
      } catch (e) {
        return ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',') + ' €';
      }
    }

    function status(message) {
      var el = form.querySelector('[data-psx-cart-status]');
      if (el) el.textContent = message || '';
    }

    function setBusy(item, busy) {
      if (!item) return;
      item.classList.toggle('is-updating', busy);
      item.querySelectorAll('button,input').forEach(function (control) {
        control.disabled = busy;
      });
    }

    function syncCartCount(count) {
      document.querySelectorAll('.psx-cart-link').forEach(function (link) {
        link.textContent = 'Carrito (' + count + ')';
      });
      document.querySelectorAll('.psx-mobile-menu a[href*="/cart"]').forEach(function (link) {
        link.textContent = 'Carrito (' + count + ')';
      });
    }

    function updateQuantity(input, quantity) {
      var key = input.dataset.key;
      var item = input.closest('[data-psx-cart-item]');
      quantity = Math.max(0, parseInt(quantity, 10) || 0);
      input.value = quantity;
      setBusy(item, true);
      status('Actualizando carrito…');

      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('No se pudo actualizar el carrito');
          return response.json();
        })
        .then(function (cart) {
          syncCartCount(cart.item_count);
          var total = form.querySelector('[data-psx-cart-total]');
          if (total) total.textContent = money(cart.total_price);

          var updatedItem = cart.items.find(function (entry) { return entry.key === key; });
          if (!updatedItem) {
            if (item) item.remove();
          } else {
            input.value = updatedItem.quantity;
            var linePrice = item && item.querySelector('[data-psx-line-price]');
            if (linePrice) linePrice.textContent = money(updatedItem.final_line_price);
          }

          if (cart.item_count === 0) {
            window.location.reload();
            return;
          }

          setBusy(item, false);
          status('Carrito actualizado');
          window.setTimeout(function () { status(''); }, 1200);
        })
        .catch(function () {
          setBusy(item, false);
          status('No se pudo actualizar. Inténtalo de nuevo.');
        });
    }

    function schedule(input, quantity, delay) {
      var key = input.dataset.key;
      if (timers.has(key)) window.clearTimeout(timers.get(key));
      timers.set(key, window.setTimeout(function () {
        timers.delete(key);
        updateQuantity(input, quantity);
      }, delay));
    }

    form.addEventListener('click', function (event) {
      var plus = event.target.closest('[data-psx-qty-plus]');
      var minus = event.target.closest('[data-psx-qty-minus]');
      var remove = event.target.closest('[data-psx-remove]');

      if (plus || minus) {
        var qty = event.target.closest('[data-psx-qty]');
        var input = qty && qty.querySelector('[data-psx-qty-input]');
        if (!input) return;
        var current = parseInt(input.value, 10) || 0;
        var next = plus ? current + 1 : Math.max(0, current - 1);
        input.value = next;
        schedule(input, next, 180);
        return;
      }

      if (remove) {
        var item = remove.closest('[data-psx-cart-item]');
        var input = item && item.querySelector('[data-psx-qty-input]');
        if (input) schedule(input, 0, 0);
      }
    });

    form.addEventListener('input', function (event) {
      var input = event.target.closest('[data-psx-qty-input]');
      if (!input) return;
      schedule(input, input.value, 500);
    });

    form.addEventListener('change', function (event) {
      var input = event.target.closest('[data-psx-qty-input]');
      if (!input) return;
      schedule(input, input.value, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPsxCart);
  } else {
    initPsxCart();
  }

  document.addEventListener('shopify:section:load', initPsxCart);
})();
